import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import CommissionPolicyList from './commission-policy-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Commission Policies">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Commission Policies</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <CommissionPolicyList />
    </Panel>
  );
};

export default Page;
